module.exports = __webpack_public_path__ + "static/circle-ch-flag-c3f4569408d6f118a21bf153919515c4.svg";